import React from "react";

import { Link } from "react-router-dom";

import { motion, AnimatePresence } from "framer-motion";

import { ArrowUpRight } from "lucide-react";

import { HERO_TRANSITION } from "@/lib/heroMotion";



const HeroPriceCard = ({

  slideKey,

  tag,

  productName,

  price,

  note,

  ctaTo,

  accent = "#2A2622",

  disableMotion = false,

}) => {

  const card = (

    <div className="hero-price-card" data-testid="hero-price" style={{ "--hero-accent": accent }}>

      <div className="hero-price-tag">

        <span className="hero-price-tag-k">{tag}</span>

        {productName && productName !== tag && (

          <p className="hero-price-name" data-testid="hero-product-name">

            {productName}

          </p>

        )}

      </div>

      {price && <div className="hero-price-amt" data-testid="hero-product-price">{price}</div>}

      <div className="hero-price-note">{note}</div>

      <Link to={ctaTo} className="hero-price-cta" data-testid="hero-price-cta">

        <span>Reserve</span>

        <ArrowUpRight size={13} strokeWidth={1.7} />

      </Link>

    </div>

  );



  if (disableMotion) return card;



  return (

    <AnimatePresence mode="wait" initial={false}>

      <motion.div

        key={slideKey}

        initial={{ opacity: 0, y: 12 }}

        animate={{ opacity: 1, y: 0 }}

        exit={{ opacity: 0, y: -8 }}

        transition={HERO_TRANSITION}

        className="hero-price-card"

        data-testid="hero-price"

        style={{ "--hero-accent": accent }}

      >

        <div className="hero-price-tag">

          <span className="hero-price-tag-k">{tag}</span>

          {productName && productName !== tag && (

            <p className="hero-price-name" data-testid="hero-product-name">

              {productName}

            </p>

          )}

        </div>

        {price && <div className="hero-price-amt" data-testid="hero-product-price">{price}</div>}

        <div className="hero-price-note">{note}</div>

        <Link to={ctaTo} className="hero-price-cta" data-testid="hero-price-cta">

          <span>Reserve</span>

          <ArrowUpRight size={13} strokeWidth={1.7} />

        </Link>

      </motion.div>

    </AnimatePresence>

  );

};



export default HeroPriceCard;

